import { render, staticRenderFns } from "./CardBrandBadge.vue?vue&type=template&id=c9879b54&scoped=true&"
import script from "./CardBrandBadge.vue?vue&type=script&lang=js&"
export * from "./CardBrandBadge.vue?vue&type=script&lang=js&"
import style0 from "./CardBrandBadge.vue?vue&type=style&index=0&id=c9879b54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9879b54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
